import type { SelectedProductTile } from '@epilot/journey-logic-commons'
import { isObject } from 'radashi'

const isSelectedProductTile = (value: unknown): value is SelectedProductTile =>
  isObject(value) && 'product' in value

export const isSelectedProductTileOrSelectedProductTileArray = (
  value: unknown
) =>
  (Array.isArray(value) && value.every(isSelectedProductTile)) ||
  isSelectedProductTile(value)
